import { useUserData } from 'components/user/hooks/use-user-data';
import { classNames } from 'components/class-names';
import { Link } from 'components/router/Link';
import { Button } from 'components/button/Button';
import * as React from 'react';
import SvgSprite from 'components/html-elements/SvgSprite';
import { When } from 'react-if';

var CartNotifierLink = function CartNotifierLink(_ref) {
  var count = _ref.count,
      createProjectModalShow = _ref.createProjectModalShow;
  var userData = useUserData();

  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SvgSprite, {
      id: "cart",
      size: 16
    }), /*#__PURE__*/React.createElement(When, {
      condition: count
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-weight-bold ml-4p"
    }, count)));
  };

  var className = classNames('text-decoration-none text-reset d-flex align-items-center mr-16p mr-xl-0');

  if (userData.hasProjects) {
    return /*#__PURE__*/React.createElement(Link, {
      to: "/cart",
      className: className
    }, renderContent());
  }

  return /*#__PURE__*/React.createElement(Button, {
    additionalClassName: className,
    onClick: createProjectModalShow
  }, renderContent());
};

export { CartNotifierLink };